var $ = require('jquery')

require('mobile/widgets/playVideo')
require('mobile/widgets/swiperLargePic')

$(function() {

  var section = $('.pn-detail')
  if (!section.length) { return }

  var swiperHor = function() {
    var _this = $(this);
    var tab_swiper = new Swiper(_this, {
      slidesPerView: 'auto',
      freeMode: true
    });
  };
  $('.js-swiper-hor').each(swiperHor);

  if ($('.mod-summary').length) {
    var convertRem = require('mods/convertRem')
    , setupModSummary = require('shouyou/widgets/modSummary')

    setupModSummary({
      lineHeight: convertRem(1.388)
    , maxColumns: 4
    , moreBtnTmpl:
        '<div class="bt-more">'
      + '<a href="javascript:;" class="label">显示全部</a></div>'
    , expandLabel: '收起部分'
    , collapseLabel: '显示全部'
    })
  }

  $('.law').on('click',function(){
    $('.area-content .tab a:eq(1)').trigger('click')
  })
})